// Sonar/common/schemas/collections/alerts.js
import { z } from "zod";

const AlertSchema = z.object({
    _id: z.string().optional(),
    monitorId: z.string(),
    userId: z.string(),
    subscriptionId: z.string(),

    title: z.string().min(1, "Alert title is required."),
    content: z.string().min(1, "Alert content is required."),
    sourceUrl: z.string().url().optional().nullable(),
    
    deliveryStatus: z.enum(["pending", "sent", "failed"]).default("pending"),
    isRead: z.boolean().default(false),

    createdAt: z.coerce.date().optional(),
});

export default AlertSchema;